import * as React from 'react';
import omit from 'omit.js';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
import Element from './Element';
// eslint-disable-next-line react/prefer-stateless-function
class SkeletonAvatar extends React.Component {
    constructor() {
        super(...arguments);
        this.renderSkeletonAvatar = ({ getPrefixCls }) => {
            const { prefixCls: customizePrefixCls, className, active } = this.props;
            const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
            const otherProps = omit(this.props, ['prefixCls']);
            const cls = classNames(prefixCls, className, `${prefixCls}-element`, {
                [`${prefixCls}-active`]: active,
            });
            return (<div className={cls}>
        <Element prefixCls={`${prefixCls}-avatar`} {...otherProps}/>
      </div>);
        };
    }
    render() {
        return <ConfigConsumer>{this.renderSkeletonAvatar}</ConfigConsumer>;
    }
}
SkeletonAvatar.defaultProps = {
    size: 'default',
    shape: 'circle',
};
export default SkeletonAvatar;
